export const ORGANIZATION_TYPES = {
    CAMPAIGN: 1,
    LEGISLATIVE: 2,
};